<template>
  <div class="BomPartsAlternativeTableComponent DataTables">
  
    

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <!-- <span v-show="!isData">{{lang.NoContent}}</span> -->
    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'
import IconSvg from '@/components/shared/IconSvg'

export default {
  name: 'BomPartsAlternativeTableComponent',
  props:{
    lang: Object,
    parent: String,
    tabIndex: Number
  },
  components: {
    LoaderComponent,
    IconSvg,
  },
  data () {
      return {
        name: 'BomPartsAlternativeTableComponent',
        mainTable: "",
        id: 'BomPartsAlternativeTableComponent' + String(this._uid),
        columns: [],
        colsAssign: [],
        parts: [],
        isData: false,
        endoflife: null,
        endofsale: null,


      }
  },
  computed: {
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;
      // if (this.$store.getters.selectedRows[0] != undefined){
      //   return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
      // }
      // return ""

    },
    projectId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.projectId;
      // if (this.$store.getters.selectedRows[0] != undefined){
      //   return this.$store.getters.selectedRows[0].col___revisionId.projectId;
      // }
      // return ""
    },
    reloadedAfterAction(){
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {

    
    this.createTable(); 


  },
  watch: {
    tabIndex: function (newVal, oldVal) {
        if (this.mainTable != ""){
          this.mainTable.rows().deselect();
        }
    },
    
    
    reloadedAfterAction: {
      handler: function (newValue, oldValue) {
        
        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {
              
              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable() {
      this.isData = false;
      let vue = this;

      

      const obj = {
          bomId: this.$store.getters.selectedBomRow[0].bomId
      }  
        

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBomWithPhysicals", obj)
      .then((result) => {
        console.log(result.data)
        if (result.status == "OK"){

          if (result.data.parts != null) {

            for (let i = 0, lei = result.data.parts.length; i < lei; i++){
              let trig = false;
              for (let j = 0, lej = result.data.parts[i].alternatives.length; j < lej; j++) {
                if (result.data.parts[i].alternatives[j].endOfPartAlert == true) {
                  trig = true;
                }

              }
              if (trig == true) {
                result.data.parts[i].endOfPartAlert = true;
              } else {
                result.data.parts[i].endOfPartAlert = false;
              }

            }


            
            this.parts = result.data.parts;
            vue.isData = true;  
            


            vue.buildColumns();
          }
          


        }else{
            vue.isData = false;  
        }


      })
    },
    alternatives (data) {

      
        
        let tr = '<tr>' +
                  '<td>' + this.lang.table_header_No + '</td>'+
                  '<td>' + this.lang.table_header_ManufacturerName + '</td>'+
                  '<td>' + this.lang.table_header_ManufacturerPartNumber + '</td>'+
                  '<td>' + this.lang.table_header_Description + '</td>'+
                  '<td>' + this.lang.table_header_Selected + '</td>'+
              '</tr>'
        let count = 0; 
        for (let i = 0, lei = data.alternatives.length; i < lei; i++){
          let checked = "checked";
          count = i + 1;
          
          if (data.alternatives[i].isSelected == false){
            checked = "";
          }
          
          tr += '<tr>'+
                    '<td>' + count + '</td>'+
                    '<td>' + data.alternatives[i].ManufacturerName + '</td>'+
                    '<td>' + data.alternatives[i].ManufacturerPartNumber + '</td>'+
                    '<td>' + data.alternatives[i].Description + '</td>'+
                    //'<td>' + rank + '</td>'+
                    
                    '<td>' + "<div class=\"custom-control custom-checkbox input-props\"><input " + checked + " type=\"checkbox\" class=\"custom-control checkbox_select_alternative custom-control-primary custom-control-sm\" id=\"request__" + data.partId + "__" + data.alternatives[i].DistributorPartId + "__" + data.PartReference +"\" value=\"true\"></div>"+ '</td>'+
                '</tr>'
        }     
           
        const table =  '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">'+
                        tr +
            
                       '</table>';
            

        return table;
    },
    buildColumns(){

      this.columns = [
        {
          name: this.lang.table_header_Expand,
          alignInColumn: "left",
          type: "text",
          width: 50
        }, 
        
        {
          name: this.lang.table_header_PartNumber,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_PartReference,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "EOL alert",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_MPNs,
          alignInColumn: "left",
          type: "text"
        },
        
        
      ]

      this.colsAssign =  [
        
        {
            "className": 'details-control',
            "orderable": false,
            "data": null,
            "defaultContent": ''
        },
        //{ "data": "bomPartId" },
        { "data": "PartNumber" },
        { "data": "Revision" },
        { "data": "PartReference"},
        { "data": "Description"},
        { "data": "revisionId" },
        { "data": "revisionId" },
        // { "data": "bomPartId"},
        // { "data": "bomPartId"},
        { "data": "bomPartId"},
               
      ]

      this.buildTable();
    },
    buildTable(){
          


          var tableplace = document.getElementById(this.id);
          if (tableplace == null) {
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "headerCell");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {

                
                if (meta.col == 0){
                  let str = '';
                  if (row.alternatives.length > 0){
                    str = '<img src="/static/plus.svg">';
                  }
                  
                  
                  let trig = false;
                  for (let i = 0, lei = row.alternatives.length; i < lei; i++){
                    
                    if (row.alternatives[i].isSelected == false){
                      str = '<img src="/static/plus.svg"> <span class="red"> ! </span>';
                      break;
                    }
                  }
                   
                  return str;
                }
                if (meta.col == 5){
                  if (data == undefined){
                      return ""
                  }
                  let str = "";
                  // if (data == 0){
                  //   str += "<b-badge class='badge badge-warning '>"+_vue.lang.tag_OutOfSync+"</b-badge>";
                  // }else{
                  //   str += "<b-badge class='badge badge-success '>"+_vue.lang.tag_Synchronized+"</b-badge>";
                  // }
                  if (row.status == "outOfSync") {
                    str += "<b-badge class='badge badge-danger '>" + _vue.lang.tag_OutOfSync + "</b-badge>";
                  } else if (row.status == "synchronized") {
                    str += "<b-badge class='badge badge-success '>" + _vue.lang.tag_Synchronized + "</b-badge>";
                  } else if (row.status == "oldRevision") {
                    str += "<b-badge class='badge badge-warning '>" + _vue.lang.tag_OldRevision + "</b-badge>";
                  }
                  if (row.isManual == true) {
                    str += " <b-badge class='badge badge-info '>" + _vue.lang.tag_IsManual + "</b-badge>";
                  }
                  if (row.isPresent == false) {
                    str += " <b-badge class='badge badge-danger '>" + _vue.lang.tag_IsNotPresent + "</b-badge>";
                  }
                  return str;
                }

                if (meta.col == 6) {
              if (data == undefined) {
                return ""
              }
              let str = "";
              
              if (row.endOfPartAlert == true) {
                str += "<b-badge class='badge badge-danger '>" + "End of" + "</b-badge>";
              } 
              return str;
            }
                
                
                if (meta.col == 7){
                  let str = '';
                  for (let i = 0, lei = row.alternatives.length; i < lei; i++){
                    
                    if (row.alternatives[i].isSelected == true){
                      let count = i + 1;
                      str += count + ". " + row.alternatives[i].ManufacturerName + " | " + row.alternatives[i].ManufacturerPartNumber + " | " + row.alternatives[i].Description + "\r\n<br>";
                      str += ' ';
                    }
                    
                
                  }  
                  return str;
                }

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fBl<t>ip>';
          option.data= this.parts;
          option.myColumnFormats = this.columns;
          option.select = true;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[25, 50, -1], [25, 50, "All"]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


            //reload table
            // const reloadObj = {
            //   status: true,
            //   name: "BomExtendedTableComponent"
            // }
            // _vue.$store.dispatch("reloadAfterAction", reloadObj);

          }
          option.buttons = [
          {
            extend: 'copy',
            className: 'btn-' + _vue.variant,
            exportOptions: {
                columns: ':visible'
            }
          },
          {
            extend: 'print',
            className: 'btn-' + _vue.variant,
            messageTop: function () {
              return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
            },
            exportOptions: {
              columns: ':visible'
            },
            autoPrint: true,
            style: 'fullWidth',
            
            customize: function ( win ) {
                $(win.document.body)
                    .css( 'font-size', '10pt' )
                    

                $(win.document.body).find( 'table' )
                    .addClass( 'compact' )
                    .css( 'font-size', 'inherit' );
            }
          },
          {
            extend: 'csv',
            className: 'btn-' + _vue.variant,
            exportOptions: {
              columns: ':visible'
            },
          },
          {
            extend:'excel',
            exportOptions: {
              columns: ':visible'
            },
            className: 'btn-' + _vue.variant,
              customize: function ( xlsx ){

              var sheet = xlsx.xl.worksheets['PM_BOM.xml'];


          }},
          {
            extend: 'pdfHtml5',
            messageTop: function () {
                    return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
            },
            className: 'btn-' + _vue.variant,
            exportOptions: {
              columns: ':visible'
            },
            orientation: 'landscape',
            pageSize: 'A4',
            download: 'open',
            
            styles: {
              fullWidth: {
                  fontSize: 3,
                  bold: true,
                  alignment: 'right',
                  margin: [0,1900,0,80]		
              },
              subheader: {
                  fontSize: 4
              },
              superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 5,
              }
            },
            customize: function ( doc ) {
              

              doc.pageMargins = [10,10,10,10];
              
              doc.styles.title.fontSize = 9;
              doc.defaultStyle.fontSize = 7;
              doc.styles.tableHeader.fontSize = 9;
              doc.content[0].text = doc.content[0].text.trim();
              
              let numberOfHeaders = columnDefs.length;
              
              if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
                
                doc.defaultStyle.fontSize = 5;
                doc.styles.tableHeader.fontSize = 7;
              }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
                
                doc.defaultStyle.fontSize = 5;
                doc.styles.tableHeader.fontSize = 7;
              }else if(numberOfHeaders >= 18){
                
                doc.defaultStyle.fontSize = 3;
                doc.styles.tableHeader.fontSize = 5;
              }
              
            },
            
          },
          {
          text: 'Json',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + _vue.variant,
              action: function ( e, dt, button, config ) {
                  var data = dt.buttons.exportData();

                  $.fn.dataTable.fileSave(
                      new Blob( [ JSON.stringify( data ) ] ),
                      'Parts.json'
                  );
              }
          },
          {
            extend: 'colvis',
            className: 'btn-' + _vue.variant,
            
          },
        ];



          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              console.log("DESTROY TABLE")
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );
          // this.mainTable.column( 4 ).visible( false );
          //this.mainTable.column( 6 ).visible( false );
          //this.mainTable.column( 6 ).visible( false );
          //this.mainTable.column( 7 ).visible( false );
          //this.mainTable.column( 8 ).visible( false );

          let _mainTable = this.mainTable;

          

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          let lengthplace = document.getElementById("t_"+this.id + "_length").firstChild;
          lengthplace.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");

          $('#t_'+this.id +' tbody').on('click', 'td.details-control', function (e) {
            
            
            var tr = $(this).closest('tr');
            var row = _mainTable.row( tr );
    
            if ( row.child.isShown() ) {
                // This row is already open - close it
                e.target.src = "/static/plus.svg";
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                e.target.src = "/static/minus.svg";
                
                if (row.data().alternatives.length > 0){
                  row.child( _vue.alternatives(row.data()) ).show();
                  tr.addClass('shown');
                }
                
            }
          } );

          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {

            var rowData = _mainTable.rows( indexes ).data();
            console.log("select")
            console.log(rowData[0])

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", rowData[0])

          })
          .on( 'deselect', function ( e, dt, type, indexes ) {
            console.log("deselect")
            _vue.$store.dispatch("unselectAlternative");
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
          })

          $('#t_'+this.id +" tbody").on('dblclick', 'tr', function () {

               
            let rowData = _mainTable.rows( this._DT_RowIndex ).data();

            _vue.goTo(rowData[0]);
                  
          });

          $('#t_'+this.id +' tbody').on('click', 'input', function (e) {
            
                        
            let id = e.target.id;
            let temp = id.split("__");

            let projectId = _vue.$store.getters.selectedProjectRow.projectId;

            if (projectId != undefined){

              const obj = {
                projectId: projectId,
                partId: temp[1],
                DistributorPartId: temp[2],
                PartReference: temp[3],
                isSelected: e.target.checked

              }
    
              console.log(obj)
              
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+'_selectPhysicalPartForBom', obj)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){

                  if (result.data == 1){
                    let obj = {
                      text: _vue.lang.alert_success_SelectAlternative,
                      time: 5,
                      type: "success"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                  }else{
                    let obj = {
                      text: _vue.lang.alert_error_SelectAlternative,
                      time: 15,
                      type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                  }
                  
                  
                }else{
                  let obj = {
                    text: _vue.lang.alert_error_SelectAlternative,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
                


              })
            }
            
            
          } );

          $("#t_"+this.id + ' tbody').on( 'click', 'button', function (e) {
            
            
            
            let temp = this.id.split("__")

            console.log()
            
            if (temp[0] == "button_unassign"){

                let alert_success_unassignAlternative = _vue.lang.alert_success_unassignAlternative;
                let alert_error_unassignAlternative = _vue.lang.alert_error_unassignAlternative;

                let partId = "";
                if (_vue.parent == "bom"){
                  partId = _vue.$store.getters.selectedPartBomRow.partId;
                }else{
                  partId = _vue.$store.getters.selectedRows[0].col___revisionId.partId;
                }

                let unassignParts = function(_vue){
                    let obj = {
                        partId: partId,
                        parts: [{
                            distributorPartId: temp[1]
                        }]
                    }
                   
                    _vue.$store.dispatch("unassignPhysicals", obj)
                    .then((result) => {

                        console.log(result)
                        if (result.status == "OK"){
                        //alert
                            if (result.data == 1){

                                _vue.$store.dispatch("unselectAlternative");
                                const reloadObj = {
                                    status: true,
                                    name: "BomPartsAlternativeTableComponent"
                                }
                                _vue.$store.dispatch("reloadAfterAction", reloadObj);
                                

                                const obj = {
                                text: alert_success_unassignAlternative,
                                time: 5,
                                type: "success"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }else{
                                const obj = {
                                  text: alert_error_unassignAlternative,
                                  time: 15,
                                  type: "danger"
                                }

                                _vue.$store.dispatch("displayFooterAlert", obj);
                            }


                        }
                    })
                    

                }
                        
                const obj = {
                    title: _vue.lang.alert_Title,
                    text: _vue.lang.alert_Text,
                    type: "withdraw",
                    buttons: 2,
                    size: "sm",
                    funcYes: unassignParts,
                    funcNo: "",

                }
            
                _vue.$store.dispatch("showAlert", obj);
                
                
            }
            if (temp[0] == "button_details"){

                let obj = {
                    distributorPartId: temp[1]
                }
                
                _vue.$store.dispatch("selectAlternative", obj)

                
            }
            if (temp[0] == "button_sync"){

              //let button_text =  document.getElementsByClassName("button-text");
              let button_action_sync = document.getElementsByClassName("button-action-sync");
              let spinner_button = document.getElementsByClassName("spiner-sync");
              if (spinner_button != null){
                button_action_sync[0].style.width = "60px";
                spinner_button[0].style.display = "block";
                spinner_button[0].style.float = "left";
                //button_text[0].style.display = "none";
              }

              let alert_success_syncAlternative = _vue.lang.alert_success_syncAlternative;
              let alert_error_syncAlternative = _vue.lang.alert_error_syncAlternative;

              let obj = {
                  distributorPartId: temp[1]
              }
              console.log(obj)
              _vue.$store.dispatch("pm_syncDistributorPart", obj)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){
              
                  if (result.data == 1){

                      
                      const reloadObj = {
                          status: true,
                          name: "BomPartsAlternativeTableComponent"
                      }
                      _vue.$store.dispatch("reloadAfterAction", reloadObj);
                      

                      const obj = {
                      text: alert_success_syncAlternative,
                      time: 5,
                      type: "success"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);
                  }else{
                      const obj = {
                        text: alert_error_syncAlternative + ".",
                        time: 15,
                        type: "danger"
                      }

                      _vue.$store.dispatch("displayFooterAlert", obj);
                  }


                } else {
                  const obj = {
                    text: alert_error_syncAlternative + ": " + result.message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
              })

                
            }
            // if (this.checked == true){
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addAlternativePart", obj)
              
            // }else{
            //   _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteAlternativePart", obj)
              
            // }
            

            

          })


        },
      goTo(goalObj){
      console.log(goalObj)

      if (goalObj.revisionId == 0){

        let obj = {
          text: this.lang.alert_OutOfSync,
          time: 15,
          type: "warning"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return
      }
      let from = "/ProjectManager/ProjectBom";

      let to = "/PartManager/PartDetails";
      let elementRevisionId = goalObj.revisionId;
      let id = goalObj.partId;
      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          partId: goalObj.partId
        },
        col___revision: {
          revisionId: goalObj.revisionId
          
        },
        col___status: {
          assembly: ""
          
        }
      }

      
      console.log(obj)
      const goToObj = {
        to: {
          path: to,
          revisionId: elementRevisionId,
          id: id
        },
        back: {
          path: from,
          revisionId: this.revisionId,
          id: this.projectId
        },
        bom: {
          selectedBomRow: this.$store.getters.selectedBomRow[0]
        }
      }
      this.$store.dispatch("goTo", goToObj);
      


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedBomRow");

      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);



      

        const query = {
          from: this.$route.path,
          to: to,
          revisionId: elementRevisionId,
          id: id,
          sourceId: this.projectId,
          sourceRevisionId: this.revisionId,
          end: false
        }

        this.$router.push({ path: to, query: query });
    },

  }
}
</script>


<style lang="scss">
  @import "./../../scss/_custom.scss";
.BomPartsAlternativeTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space: nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 320px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    td.details-control {
      //background: url("/static/plus.svg") no-repeat center center;
      img{
        max-width: 30px;
        padding: 2px;  
      }
      
    }
    tr.shown td.details-control {
      img{
        max-width: 30px;
        padding: 2px;  
      }
      //background: url("/static/minus.svg") no-repeat center center;
    }
    .button-action-unassign{
        margin: 2px;
    }
    .button-action-sync{
        margin: 2px;
    }
    .spiner-sync{
      display: none;
    }
    .red{
      color: $redfont;
    }
    .badge {
      margin: 2px;
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BomPartsAlternativeTableComponent.vue